<script setup lang="ts">
defineProps({
  title: {
    type: String,
    default: 'Bestätigung',
  },
  confirmText: {
    type: String,
    default: 'Bestätigen',
  },
  cancelText: {
    type: String,
    default: 'Abbrechen',
  },
})

defineEmits<{
  close: [boolean]
}>()
</script>

<template>
  <UModal
    :close="{ onClick: () => $emit('close', false) }"
    :title="title"
    :dismissible="false"
  >
    <slot />
    <template #body>
      <slot name="body" />
    </template>
    <template #footer>
      <div class="w-full flex justify-end">
        <n-button
          @click="() => $emit('close', false)"
        >
          <slot name="cancelText">
            {{ cancelText }}
          </slot>
        </n-button>
        <n-button
          type="warning"
          @click="() => $emit('close', true)"
        >
          <slot name="confirmText">
            {{ confirmText }}
          </slot>
        </n-button>
      </div>
    </template>
  </UModal>
</template>
